import React, { Fragment } from "react";

import IObservation from "../../interfaces/IObservation";
import { PersonName } from "../person/PersonName";
import { FormTypeName } from "../formType/FormTypeName";
import { Header, Label, Icon, Divider } from "semantic-ui-react";
import { StatusColors } from "../../constants/statusColors";
import { useTranslatedStatus } from "../../constants/statusTextKey";

import { useTranslation } from "react-i18next";
import { formatIdLabel, getReadableTimestamp } from "../../utils/havainnot.helper";
import { useApplicationConfiguration } from "../../configuration/ConfigurationContext";
import { TFunction } from "i18next";

const getTextProps = (t: TFunction) => ({
    public: t("Julkinen"),
    notPublic: t("Ei julkinen"),
    createdAt: t("Luotu"),
    informer: t("Ilmoittaja"),
    currentHandler: t("Nykyinen käsittelijä"),
});
/**
 * Dsiplays general info about the observation
 *  - these fields are same depending on category or formType.
 *  - use SchemaDisplay component to show data stored inside formData.
 */

interface IObservationDetail {
    observation: IObservation;
    hiddenDivider?: boolean;
    onlyStaticData?: boolean;
    showNameDetail: boolean;
}

const ObservationDetail: React.FC<IObservationDetail> = ({
    observation,
    showNameDetail,
    onlyStaticData = false,
    hiddenDivider = false,
}) => {
    const {
        components: { LocationName },
        showUniqueObservationId,
    } = useApplicationConfiguration();
    const texts = getTextProps(useTranslation().t);
    const labelColor = StatusColors[observation.status];
    const statusLabelText = useTranslatedStatus(observation.status);

    return (
        <>
            <Header as="h3" size="medium">
                {" "}
                {observation.title}{" "}
            </Header>

            <Label className="ObservationDetail-label" color={labelColor} title={texts.informer}>
                <Icon name="user" />
                <FormTypeName formTypeId={observation.formType} />
                {showUniqueObservationId && (
                    <span style={{ fontWeight: "lighter" }}>
                        {"  "} {formatIdLabel(observation.id)}
                    </span>
                )}
            </Label>

            <Divider hidden={hiddenDivider} />

            {observation.target ? (
                <div>
                    <Icon name="marker" />
                    <LocationName locationId={observation.target} />
                </div>
            ) : null}

            {showNameDetail && (
                <div>
                    <Icon name="user" />
                    {observation.creator ? <PersonName personId={observation.creator} /> : null}
                </div>
            )}

            <div title="Luotu">
                <Icon name="calendar" /> {texts.createdAt}: {getReadableTimestamp(observation.created_at)}
            </div>

            {!onlyStaticData && (
                <Fragment>
                    {observation.editor && (
                        <div title={texts.currentHandler}>
                            <Icon name="user outline" /> <PersonName personId={observation.editor} />
                        </div>
                    )}

                    <div>
                        {observation.is_public ? <Icon name="eye" /> : <Icon name="eye slash" />}
                        {observation.is_public ? texts.public : texts.notPublic}
                    </div>

                    <div>
                        <Icon name="circle" color={StatusColors[observation.status]} /> {statusLabelText}
                    </div>
                </Fragment>
            )}
        </>
    );
};

export default ObservationDetail;
